var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBokkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#EDF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1385 22.3118L26.7369 18.513H23.0507V16.0438C23.0507 15.0051 23.5653 13.9901 25.2109 13.9901H26.9104V10.7552C25.9207 10.5975 24.9207 10.5122 23.9184 10.5C20.8844 10.5 18.9036 12.3222 18.9036 15.6164V18.513H15.5405V22.3118H18.9036V31.5H23.0507V22.3118H26.1385Z",
    fill: "#337FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBokkIcon);
export default __webpack_public_path__ + "static/media/FaceBokkIcon.208adf1537fae82fcf6ff785aa5c5b09.svg";
export { ForwardRef as ReactComponent };